package fyi.moko.hotpl.data.network

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Int8Array
import org.khronos.webgl.Uint8Array

/** A Kotlin/JS ByteArray is an Int8Array; the Storage SDK wants the same buffer as Uint8Array. */
internal actual fun ByteArray.toStorageData(): Data {
    val signed = unsafeCast<Int8Array>()
    return Data(Uint8Array(signed.buffer, signed.byteOffset, signed.length))
}
